import { Routes } from '@angular/router';

export const categoriesRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/categories/categories.component').then(c => c.CategoriesComponent),
    data: { pageTitle: 'PAGES.CATEGORIES.TITLE', pageType: 'list' }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-category/add-edit-category.component').then(c => c.AddEditCategoryComponent),
    data: { pageTitle: 'PAGES.CATEGORIES.ADD', pageType: 'add' }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-category/add-edit-category.component').then(c => c.AddEditCategoryComponent),
    data: { pageTitle: 'PAGES.CATEGORIES.EDIT', pageType: 'edit' }
  },
  {
    path: 'view/:id',
    loadComponent: () => import('./pages/category/category.component').then(c => c.CategoryComponent),
    data: { pageTitle: 'PAGES.CATEGORIES.DETAILS', pageType: 'details' }
  }
];
